import React from "react";
import ReactDOM from "react-dom/client";
import JSXRuntime from "react/jsx-runtime";
import { externalizedPackages } from "./index.js";

// This file re-exports all dependencies defined in index.js on the window object
// The build result can then be shared across all modules using this vendor preset
const packages: Record<string, unknown> = {
    React,
    ReactDOM,
    JSXRuntime,
};

// Check if these imports are in sync with their definition in index.js
const externalizedValues = Object.values(externalizedPackages);
const missingInPackages = externalizedValues.filter((pkg) => !packages[pkg]);
const missingInExternalized = Object.keys(packages).filter((key) => !externalizedValues.includes(key));

if (missingInPackages.length > 0 || missingInExternalized.length > 0) {
    const packages = Array.from(new Set([...missingInPackages, ...missingInExternalized]).values()).join(", ");
    throw new Error("Externalized packages in vendor-react are not in sync: " + packages);
}

// TODO: TBD: this approach risks version conflicts, it also breaks tree-shaking (170kb -> 550kb for basic example)
Object.entries(packages).forEach(([key, value]) => {
    (window as unknown as Record<string, unknown>)[key] = value;
});

export default packages;
